import { stateGo } from 'redux-ui-router';
import { createMealPlan } from 'logic/mealPlan';
import { selectMemberLevel } from 'logic/member';

export const MealPlanCreateButton = {
  transclude: true,

  bindings: {
    style: '@',
    subscriptionId: '<',
  },

  template: `
    <span ng-switch="$ctrl.style">
      <span ng-switch-when="link">
        <button-link ng-click="$ctrl.onClick($ctrl.subscriptionId)">
          <ng-transclude></ng-transclude>
        </button-link>
      </span>
      <span ng-switch-when="button">
        <button-primary
          ng-click="$ctrl.onClick($ctrl.subscriptionId)">
          <ng-transclude></ng-transclude>
        </button-primary>
      </span>
    </span>`,

  controller($ngRedux, $state) {
    'ngInject';

    return {
      $onDestroy() {
        this.unsubscribe && this.unsubscribe();
      },

      onClick(subscriptionId) {
        this.unsubscribe = $ngRedux.subscribe(() => this.redirectOnCreate());
        $ngRedux.dispatch(createMealPlan(subscriptionId));
      },

      redirectOnCreate() {
        const { mealPlan, member } = $ngRedux.getState();

        if (mealPlan.result) {
          this.unsubscribe();

          // TODO: do a hard redirect to edit, due to some issues with the state
          // updating and a race condition.
          window.location.assign(
            $state.href('nutrition.mealPlans.detail.edit', {
              mealPlanId: mealPlan.result,
              day: 'Monday',
              level: selectMemberLevel(member),
            })
          );

          // $ngRedux.dispatch(
          //   stateGo('nutrition.mealPlans.detail.edit', {
          //     mealPlanId: mealPlan.result,
          //     day: 'Monday',
          //     level: selectMemberLevel(member),
          //   })
          // );
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanCreateButton.js